const breakpoints = {
    xs: "375px",
    sm: "576px",
    md: "992px",
    lg: "992px",
    xl: "1600px",
};

export default breakpoints;
